import { useSelector } from 'react-redux'

export interface User {
  id: number
  email: string | null
  name: string | null
}

export default function useOrgUsers(): User[] {
  return useSelector((state: any) => state.org.allUsers)
}
